import { render } from "./CoordinateHome.vue?vue&type=template&id=d16f2976"
import script from "./CoordinateHome.vue?vue&type=script&lang=js"
export * from "./CoordinateHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__